import styled from "styled-components";

import { Button } from "components/ui";

import { media } from "constants/media";

export const Wrapper = styled.div`
    align-items: flex-start;
    background: var(--color-white);
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    gap: 38px;
    padding: 24px;

    /* stylelint-disable-next-line no-descending-specificity */
    > span {
        color: var(--color-grey-55);
        cursor: pointer;
        display: block;
        margin-top: 8px;

        &:hover {
            color: var(--color-primary);
        }
    }

    ${media.mdUp} {
        padding: 32px;
    }

    ${media.lgUp} {
        flex-direction: row;

        svg {
            flex-shrink: 0;
        }
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    ${media.mdUp} {
        gap: 16px;
    }
`;
export const Description = styled.p``;

export const Bold = styled.p`
    font-weight: var(--font-weight-extra-bold);
`;

export const FilterOptionsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export const FilterOption = styled.span`
    align-items: center;
    background: var(--color-grey-50);
    border-radius: 16px;
    cursor: pointer;
    display: flex;
    font-size: var(--type-paragraph-font-size);
    font-weight: 700;
    gap: 12px;
    letter-spacing: 1px;
    margin-bottom: 4px;
    padding: 4px 8px;

    /* stylelint-disable-next-line no-descending-specificity */
    svg {
        margin-right: 0;
    }

    &:hover {
        background-color: var(--color-white);
        outline: 1px solid var(--color-black);
    }
`;

export const Reset = styled.p`
    color: var(--color-grey-55);
    cursor: pointer;
`;

export const Line = styled.div`
    background: var(--color-grey-50);
    height: 1px;
    width: 100%;
`;

export const StyledButton = styled(Button)`
    justify-content: center;
    margin: 0 auto;
    margin-top: 24px;
    padding-right: 24px;
    width: 100%;

    ${media.mdUp} {
        margin: 0;
        width: fit-content;
    }
`;
